import { Box, IconButton, SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as FacebookIcon } from 'assets/social-icons/facebook.svg';
import { ReactComponent as InstagramIcon } from 'assets/social-icons/instagram.svg';
import { ReactComponent as LinkedinIcon } from 'assets/social-icons/linkedin.svg';
import { ReactComponent as TwitterIcon } from 'assets/social-icons/twitter.svg';
import { ReactComponent as TelegramIcon } from 'assets/social-icons/telegram.svg';
import React from 'react';

const useStyle = makeStyles((theme) => {
    return {
        socialShareButtons: {
            display: 'flex',
            alignItems: 'center',
            '& a': {
                marginRight: theme.spacing(0.75),
            },
            '& svg': {
                fontSize: '1.2rem',
                color: theme.palette.text.secondary,
            },
            [theme.breakpoints.down('sm')]: {
                marginRight: theme.spacing(0.25),
            },
        },
    };
});

export const SocialButtons: React.FC = () => {
    const classes = useStyle();

    return (
        <Box className={classes.socialShareButtons}>
            <a rel="noreferrer noopener" target="_blank" href="https://www.facebook.com/staffy.az/">
                <IconButton>
                    <SvgIcon component={FacebookIcon} />
                </IconButton>
            </a>
            <a rel="noreferrer noopener" target="_blank" href="https://www.instagram.com/staffy.az/">
                <IconButton>
                    <SvgIcon component={InstagramIcon} />
                </IconButton>
            </a>

            <a rel="noreferrer noopener" target="_blank" href="https://twitter.com/jobyfy_io">
                <IconButton>
                    <SvgIcon component={TwitterIcon} />
                </IconButton>
            </a>
            <a rel="noreferrer noopener" target="_blank" href="https://linkedin.com/company/staffyaz/">
                <IconButton>
                    <SvgIcon component={LinkedinIcon} />
                </IconButton>
            </a>
            <a rel="noreferrer noopener" target="_blank" href="https://t.me/staffyaz">
                <IconButton>
                    <SvgIcon component={TelegramIcon} />
                </IconButton>
            </a>
        </Box>
    );
};
